import { render, staticRenderFns } from "./FlameGraphNode.vue?vue&type=template&id=48af2e7d&scoped=true"
import script from "./FlameGraphNode.vue?vue&type=script&lang=js"
export * from "./FlameGraphNode.vue?vue&type=script&lang=js"
import style0 from "./FlameGraphNode.vue?vue&type=style&index=0&id=48af2e7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48af2e7d",
  null
  
)

export default component.exports